import { useLocation, useParams } from 'react-router-dom'
import { useUrlParams } from 'constants/routesPathEnumSsr'

export const SpotTDKLanguageKeys = {
    titleKey: 'seo.usdt_spot_title',
    descKey: 'seo.usdt_spot_desc'
}

export const getFuturesLangKeys = (businessLine: string, symbolId: string) => {
    let titleKey = ''
    let descKey = ''
    switch (businessLine) {
        // U本位合约
        case 'usdt':
            titleKey = 'seo.usdt_futures_title'
            descKey = 'seo.usdt_futures_desc'
            break
        // U本位合约模拟交易
        case 'susdt':
            titleKey = 'seo.usdt_futures_demo_title'
            descKey = 'seo.usdt_futures_demo_desc'
            break
        // USDC合约
        case 'usdc':
            titleKey = 'seo.usdc_perpetual_futures_title'
            descKey = 'seo.usdc_perpetual_futures_desc'
            break
        // USDC本位合约模拟交易
        case 'susdc':
            titleKey = 'seo.usdc_perpetual_futures_demo_title'
            descKey = 'seo.usdc_perpetual_futures_demo_desc'
            break
        // 币本位合约 - 永续合约/交割合约
        case 'usd':
            const isSettled = symbolId?.split('_').length === 3
            if (isSettled) {
                // 币本位合约 - 结算交割合约
                titleKey = 'seo.coin_settled_delivery_futures_title'
                descKey = 'seo.coin_settled_delivery_futures_desc'
            } else {
                // 币本位合约 - 永续合约
                titleKey = 'seo.coin_settled_perpetual_futures_title'
                descKey = 'seo.coin_settled_perpetual_futures_desc'
            }
            break
        // 币本位合约模拟交易 - 永续合约/交割合约
        case 'susd':
            const isSettledDemo = symbolId?.split('_').length === 3
            if (isSettledDemo) {
                // 币本位合约模拟交易 - 结算交割合约
                titleKey = 'seo.coin_delivery_futures_demo_title'
                descKey = 'seo.coin_delivery_futures_demo_desc'
            } else {
                // 币本位合约模拟交易 - 永续合约
                titleKey = 'seo.coin_perpetual_futures_demo_title'
                descKey = 'seo.coin_perpetual_futures_demo_desc'
            }
            break
        default:
            break
    }
    return { titleKey, descKey }
}
export const useFuturesLangKeys = () => {
    const { pathname, search } = useLocation()
    const routeParams = useParams()
    const { businessLine, symbolId } = useUrlParams(routeParams, pathname, search)
    return getFuturesLangKeys(businessLine, symbolId)
}

// export const getFuturesInfoLangKeys = (pathname: string) => {
//     let titleKey = ''
//     let descKey = ''
//     switch (pathname) {
//         // 资金费率
//         case '/futures/introduction/funding-rate':
//             titleKey = 'seo.introduction_funds_rate_title'
//             descKey = 'seo.introduction_funds_rate_desc'
//             break
//         // 风险准备金
//         case '/futures/introduction/provision-for-risks': // todo 有问题?
//             titleKey = 'seo.introduction_risk_foundation_title'
//             descKey = 'seo.introduction_risk_foundation_desc'
//             break
//         // 交割合约
//         case '/futures/introduction/delivery-data':
//             titleKey = 'seo.introduction.delivery-data_title'
//             descKey = 'seo.introduction.delivery-data_desc'
//             break
//         // 仓位档位介绍
//         case '/futures/introduction/position-tier':
//             titleKey = 'seo.introduction_position_level_title'
//             descKey = 'seo.introduction_position_level_desc'
//             break
//         // 风控条款
//         case '/futures/introduction/position-limit':
//             titleKey = 'seo.introduction_open_limit_title'
//             descKey = 'seo.introduction_open_limit_desc'
//             break
//         // 指数
//         case '/futures/introduction/price-indexes':
//             titleKey = 'seo.introduction_price_history_title'
//             descKey = 'seo.introduction_price_history_desc'
//             break
//         default:
//             break
//     }
//
//     return { titleKey, descKey }
// }


export const getFuturesInfoLangKeys = (pathname: string) => {
    const LANG_KEYS = {
        '/spot/introduction/spot-rules': {
            title: 'seo.spot.rules_title',
            desc: 'seo.spot.rules_desc'
        },
        '/margininfo': {
            title: 'seo.margininfo_title',
            desc: 'seo.margininfo_desc'
        },
        '/futures/introduction/futures-summarize': {
            title: 'seo.futures.futures-summarize_title',
            desc: 'seo.futures.futures-summarize_desc'
        },
        '/futures/introduction/margin-summarize': {
            title: 'seo.futures.margin-summarize_title',
            desc: 'seo.futures.margin-summarize_desc'
        },
        '/futures/introduction/liquidation-summarize': {
            title: 'seo.futures.liquidation-summarize_title',
            desc: 'seo.futures.liquidation-summarize_desc'
        },
        '/futures/introduction/order-summarize': {
            title: 'seo.futures.order-summarize_title',
            desc: 'seo.futures.order-summarize_desc'
        },
        '/futures/introduction/trading-fee': {
            title: 'seo.futures.tading-fee_title',
            desc: 'seo.futures.tading-fee_desc'
        },
        '/futures/introduction/futures-details': {
            title: 'seo.futures.futures-details_title',
            desc: 'seo.futures.futures-details_desc'
        },
        '/futures/introduction/trading-parameters': {
            title: 'seo.futures.trading-parameters_title',
            desc: 'seo.futures.trading-parameters_desc'
        },
        '/futures/introduction/position-tier': {
            title: 'seo.futures.position-tier_title',
            desc: 'seo.futures.position-tier_desc'
        },
        '/futures/introduction/position-limit': {
            title: 'seo.futures.position-limit_title',
            desc: 'seo.futures.position-limit_desc'
        },
        '/futures/introduction/funding-rate': {
            title: 'seo.futures.funding-rate_title',
            desc: 'seo.futures.funding-rate_desc'
        },
        '/futures/introduction/price-indexes': {
            title: 'seo.futures.price-indexes_title',
            desc: 'seo.futures.price-indexes_desc'
        },
        '/futures/introduction/provision-for-risks': {
            title: 'seo.futures.risks_title',
            desc: 'seo.futures.risks_desc'
        }
    }

    const res = LANG_KEYS[pathname] || {title: 'seo.default_title', desc: 'seo.default_title'}
    return {
        ...res,
        titleKey: res?.title,
        descKey: res?.desc
    }

    // return LANG_KEYS[pathname] || {title: 'seo.default_title', desc: 'seo.default_title'}
}


export const useFuturesInfoLangKeys = () => {
    const { pathname } = useLocation()
    const { locales } = useParams()
    return getFuturesInfoLangKeys(locales ? pathname.replace(`/${locales}`, '') : pathname)
}

export const getTradingBotLangKeys = (pathname: string, search: string) => {
    const languageKeys = {
        spot: {
            grid: {
                title: 'seo.spot_grid_strategic_trading_title',
                desc: 'seo.spot_grid_strategic_trading_desc'
            },
            dca: {
                title: 'seo.spot_dca_strategic_trading_title',
                desc: 'seo.spot_dca_strategic_trading_desc'
            },
            timing: {
                title: 'seo.spot_timing_strategic_trading_title',
                desc: 'seo.spot_timing_strategic_trading_desc'
            },
            cta: {
                title: 'seo.trading-bot.spot.cta.rule_title',
                desc: 'seo.trading-bot.spot.cta.rule_desc'
            },
            hoard: {
                title: 'seo.trading-bot.spot.hoard_title',
                desc: 'seo.trading-bot.spot.hoard_desc'
            },
            moon: {
                title: 'seo.trading-bot.spot.moon_title',
                desc: 'seo.trading-bot.spot.moon_desc'
            }
        },
        futures: {
            grid: {
                title: 'seo.futures_grid_strategic_trading_title',
                desc: 'seo.futures_grid_strategic_trading_desc'
            },
            dca: {
                title: 'seo.futures_dca_strategic_trading_title',
                desc: 'seo.futures_dca_strategic_trading_desc'
            },
            cta: {
                title: 'seo.trading-bot.futures.cta.rule_title',
                desc: 'seo.trading-bot.futures.cta.rule_desc'
            },
            moon: {
                title: 'seo.trading-bot.futures.moon_title',
                desc: 'seo.trading-bot.futures.moon_desc'
            }
        }
    }

    let titleKey = 'seo.spot_grid_strategic_trading_title'
    let descKey = 'seo.spot_grid_strategic_trading_desc'

    //获取对应的key
    if (pathname.indexOf('spot') >= 0 || pathname.indexOf('spot-strategy') >= 0) {
        if (pathname.indexOf('dca') >= 0 || search?.indexOf('dca') >= 0) {
            titleKey = languageKeys.spot.dca.title
            descKey = languageKeys.spot.dca.desc
        } else if (pathname.indexOf('timing') >= 0 || search?.indexOf('timing') >= 0) {
            titleKey = languageKeys.spot.timing.title
            descKey = languageKeys.spot.timing.desc
        } else if (pathname.indexOf('cta') >= 0 || search?.indexOf('cta') >= 0) {
            titleKey = languageKeys.spot.cta.title
            descKey = languageKeys.spot.cta.desc
        } else if (pathname.includes('hoard')) {
            titleKey = languageKeys.spot.hoard.title
            descKey = languageKeys.spot.hoard.desc
        } else if (pathname.includes('moon')) {
            titleKey = languageKeys.spot.moon.title
            descKey = languageKeys.spot.moon.desc
        } else {
            titleKey = languageKeys.spot.grid.title
            descKey = languageKeys.spot.grid.desc
        }
    } else if (pathname.indexOf('futures') >= 0 || pathname.indexOf('future-strategy') >= 0) {
        if (pathname.indexOf('dca') >= 0 || search?.indexOf('dca') >= 0) {
            titleKey = languageKeys.futures.dca.title
            descKey = languageKeys.futures.dca.desc
        } else if (pathname.indexOf('cta') >= 0 || search?.indexOf('cta') >= 0) {
            titleKey = languageKeys.futures.cta.title
            descKey = languageKeys.futures.cta.desc
        } else if (pathname.includes('moon')) {
            titleKey = languageKeys.futures.moon.title
            descKey = languageKeys.futures.moon.desc
        } else {
            titleKey = languageKeys.futures.grid.title
            descKey = languageKeys.futures.grid.desc
        }
    }

    return { titleKey, descKey }
}

export const useTradingBotLangKeys = () => {
    const { pathname, search } = useLocation()
    return getTradingBotLangKeys(pathname, search)
}

export const useTitleLangKeys = (props: {
    isSpot?: boolean
    isFutures?: boolean
}): {
    titleKey: string
    descKey: string
} => {
    const { pathname, search } = useLocation()
    const routeParams = useParams()
    const { businessLine, symbolId } = useUrlParams(routeParams, pathname, search)
    if (props.isSpot) {
        return SpotTDKLanguageKeys
    } else if (props.isFutures) {
        return getFuturesLangKeys(businessLine, symbolId)
    }
}

export const FuturesHomeTDKLanguageKeys = {
    titleKey: 'seo.futures.index_title',
    descKey: 'seo.futures.index_desc'
}

export const TradingBotHomeTDKLanguageKeys = {
    titleKey: 'seo.trading-bot.index_title',
    descKey: 'seo.trading-bot.index_desc'
}

export const C2CHomeTDKLanguageKeys = {
    titleKey: 'seo.crypto-c2c.index_title',
    descKey: 'seo.crypto-c2c.index_desc'
}
export const C2CHomeWithTabTDKLanguageKeys = {
    titleKey: 'seo.crypto-c2c.tab_title',
    descKey: 'seo.crypto-c2c.tab_desc'
}
export const C2CDetailTDKLanguageKeys = {
    titleKey: 'seo.crypto-c2c.tab.buycoin_title',
    descKey: 'seo.crypto-c2c.tab.coin_desc'
}

export const C2CHomePreMarketTDKLanguageKeys = {
    titleKey: 'seo.pre-market.index_title',
    descKey: 'seo.pre-market.index_desc'
}

export const C2CHomePreMarketHistoryTDKLanguageKeys = {
    titleKey: 'seo.pre-market.history_title',
    descKey: 'seo.pre-market.history_desc'
}

export const C2CHomePreMarketDetailTDKLanguageKeys = {
    titleKey: 'seo.pre-market.detail_title',
    descKey: 'seo.pre-market.detail_desc'
}
